exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.currency-SelectOptionFrame[data-v-40e746d6] {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n\tmargin-bottom: 20px;\n}\n.cur-option[data-v-40e746d6] {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\tpadding: 10px;\n\tborder-radius: 5px;\n\tcursor: pointer;\n\ttransition: background-color 0.3s;\n}\n.cur-option[data-v-40e746d6]:hover, .cur-option.active[data-v-40e746d6] {\n\tbackground-color: rgba(0, 0, 0, 0.05);\n}\n.cur-option img[data-v-40e746d6] {\n\twidth: 20px;\n\theight: 20px;\n}\n", ""]);

// exports
